<template>
<div
    class="login-box"
    style="min-height: 873px;"
>
    <div class="box-header with-border">

    </div>
    <div class="login-box-body">
        <h4 class="login-box-msg">{{$t("EXPLAIN WHY YOU DENY THE REFUND OF THIS TRANSACTION")}}</h4>

        <form v-on:submit.prevent="send">

            <br>
            <br>
            <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-bookmark"></i></span>
                <textarea
                    v-model="content"
                    class="form-control"
                    rows="5"
                    id="comment"
                    placeholder="Nota - opcional"
                ></textarea>
            </div>
            <br>
            <div class="form-group has-error">
                <label
                    class="control-label"
                    for="inputError"
                >
                    {{ error_message }}
                    </label>
            </div>
            <input
                class="btn btn-primary"
                type="submit"
                value="Enviar"
            >
                <router-link
                    to="/"
                    class="btn btn-default"
                >Cancelar</router-link>
        </form>
        <div v-if="loading==true">
            <center>
                <div
                    class="fa fa-circle-o-notch fa-spin text-blue"
                    style="font-size:50px;"
                ></div>
        </center>
    </div>
    </div>

    </div>
</template>


<script>
import swal from "sweetalert";
export default {
    name: "rejecting",
    data() {
        return {
            merchanId: this.$route.params.merchanId,
            content: "",
            transactionId: this.$route.params.transactionId,
            token: this.$route.params.token,
            loading: false,
            error_message: ''
        };
    },
    methods: {
        async send() {
            try {
               
              
                   this.loading = true;
                    let response = await this.$store.state.services.petitionService.rejectExplain({
                        merchanId: this.merchanId,
                        transactionId: this.transactionId,
                        token: this.token,
                        content: this.content
                    });
                    this.loading = false;
                    this.content ='';
                    
                    swal({
                        title: this.$t("THE STATUS HAS BEEN CHANGED"),
                        text: response.data,
                        icon: "success"
                    }).then(cliked=>{
                        
                       window.close();
                    
                    });

                
            } catch (error) {
                swal({
                    title: this.$t('STATUS CHANGE FAILED'),
                    text: error.response.data.error,
                    icon: "success"
                });

            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Transactions/rejectExplaining.vue